module.exports = __webpack_public_path__ + "static/media/local-auth-background.1ec8f010.png";